import { render, staticRenderFns } from "./RightDialog.vue?vue&type=template&id=6829238c&"
import script from "./RightDialog.vue?vue&type=script&lang=js&"
export * from "./RightDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports